import { useApi } from "~/composables/useApi";

export const useContractComment = () => {
  const { invoke } = useApi();

  const getContractComments = async (contractId: string) => {
    const response = await invoke({
      path: "contract-comment/:contractId",
      method: "GET",
      params: { contractId },
    });

    if (!response.success) {
      throw new Error("Erreur lors de la récupération des commentaires du contrat", { cause: response.error });
    }

    return response;
  };

  const getLastCommentType = async (contractId: string) => {
    const { data: rows } = await getContractComments(contractId);
    return rows.length === 0 ? null : rows[0].type;
  };

  return {
    getContractComments,
    getLastCommentType,
  };
};
